import React from 'react'
import { mtc } from '../../../utils/style-helpers'

export interface ListProps {
  items?: string[]
  className?: string
  children?: React.ReactNode
  bulleted?: boolean
}

export const List: React.FC<ListProps> & {
  Item: React.FC<
    React.HTMLAttributes<HTMLLIElement> & {
      children: React.ReactNode
      className?: string
    }
  >
} = ({ items, className, children, bulleted = false }) => {
  const listClass = bulleted ? 'list-disc' : ''
  return (
    <ul
      className={mtc(`pl-2 text-neutral-600 text-sm ${listClass}`, className)}
    >
      {items
        ? items.map((item, index) => (
            <li key={index} className="mb-2">
              {item}
            </li>
          ))
        : children}
    </ul>
  )
}

interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  children: React.ReactNode
  className?: string
}

List.Item = ({ children, className, ...rest }: ListItemProps) => (
  <li className={mtc('mb-2', className)} {...rest}>
    {children}
  </li>
)

List.displayName = 'List'
